import * as React from "react";
import { forwardRef } from "react";
const SvgIcnStatusErledigt16PxGruen = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Pfad_1433", "data-name": "Pfad 1433", d: "M476.249,699.693a8,8,0,1,0,8,8A8,8,0,0,0,476.249,699.693Zm4.618,5.466-4.564,6.193a.674.674,0,0,1-.944.133l-.009-.008-3.259-2.6a.667.667,0,1,1,.834-1.041l2.717,2.174,4.151-5.634a.667.667,0,0,1,1.11.739Z", transform: "translate(-468.249 -699.693)", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcnStatusErledigt16PxGruen);
export { ForwardRef as ReactComponent };
